module.exports = __webpack_public_path__ + "img/move.d4caff6b.svg";